// extracted by mini-css-extract-plugin
module.exports = {"wave2DetailD":"D_wave2DetailD__jPpml"};